import { takeEvery, all, select, race, take, put } from 'redux-saga/effects'
import { SUCCESS, FAILED } from 'crom-api-constants'
import _ from 'lodash'

import config from '@config'
import { getLocale, getToken, getCustomData } from '@global/selectors'

import { blockSaveCustomData } from '../../../../../../../../../../../../../components/Workspace/components/HocBlock/actions'

import {
    ASSIGNED_TENDERS_LOAD_PUBLISHERS_DATA,
    ASSIGNED_TENDERS_LOAD_PUBLISHERS_DATA_REQUEST,
    ASSIGNED_TENDERS_PUBLISHERS_TABLE_LOADING_TRUE,
    ASSIGNED_TENDERS_PUBLISHERS_TABLE_LOADING_FALSE,
    ASSIGNED_TENDERS_PUBLISHERS_TABLE_LOADING_FAILED,
    ASSIGNED_TENDERS_PUBLISHERS_TABLE_DATA_RECEIVED,
} from './constants'

import {
    loadTableDataRequest,
    publishersTableLoadingTrue,
    publishersTableLoadingFalse,
    publishersTableLoadingFailed,
    publishersTableDataReceived,
} from './actions'

const ASSIGNED_TENDERS_LOAD_PUBLISHERS_DATA_REQUEST_SUCCESS = (entId, tenderId) =>
    `${ASSIGNED_TENDERS_LOAD_PUBLISHERS_DATA_REQUEST(entId, tenderId)}_${SUCCESS}`
const ASSIGNED_TENDERS_LOAD_PUBLISHERS_DATA_REQUEST_FAILED = (entId, tenderId) =>
    `${ASSIGNED_TENDERS_LOAD_PUBLISHERS_DATA_REQUEST(entId, tenderId)}_${FAILED}`

function* loadPublishersCallSaga(action) {
    const block = action?.data?.block
    if (block !== config.modules.report.blocks.procurement.key) return null

    const module = action?.data?.module
    const entId = action?.data?.entId
    const tenderId = action?.data?.tenderId
    if (!module || !entId || !tenderId) return null

    const level = action?.data?.level
    const locale = yield select(getLocale)
    const token = yield select(getToken, entId, module)

    yield put(publishersTableLoadingTrue(module, block, entId, level, tenderId, { isLoading: true }))

    let queryParams = {}
    if (!_.isEmpty(action?.data?.changeData)) {
        const changeData = action?.data?.changeData

        queryParams = {
            'sort[]': _.map(changeData?.sorted, (val) => `${val?.id}${val.desc ? ':desc' : ':asc'}`),
            page: changeData?.pagination?.page,
            rows: changeData?.pagination?.rowsPerPage,
        }
    } else {
        // default query params from config
        queryParams = config?.api?.[module]?.[block]?.tables?.publishedTendersPublishers?.qs || {}
    }

    yield put(loadTableDataRequest(module, block, entId, level, locale, token, tenderId, queryParams))

    const response = yield race({
        success: take(ASSIGNED_TENDERS_LOAD_PUBLISHERS_DATA_REQUEST_SUCCESS(entId, tenderId)),
        failed: take(ASSIGNED_TENDERS_LOAD_PUBLISHERS_DATA_REQUEST_FAILED(entId, tenderId)),
    })

    if (response.failed) {
        yield put(
            publishersTableLoadingFailed(module, block, entId, level, tenderId, {
                isLoading: false,
                loaded: true,
                failed: true,
            })
        )
        return null
    }

    const responseBody = response?.success?.payload?.response?.body

    yield put(
        publishersTableDataReceived(module, block, entId, level, tenderId, {
            data: responseBody?.publishers,
            loaded: true,
            dataLocale: locale,
            failed: false,
        })
    )

    yield put(publishersTableLoadingFalse(module, block, entId, level, tenderId, { isLoading: false }))

    return null
}

function* assignedTendersPublishersSaveCustomDataCallSaga(action) {
    const blockKey = action?.data?.block
    if (blockKey !== config.modules.report.blocks.procurement.key) return null

    const module = action?.data?.module
    const entId = action?.data?.entId
    const tenderId = action?.data?.tenderId
    if (!module || !entId || !blockKey || !tenderId) return null

    const customData = yield select(getCustomData, module, blockKey, entId)
    const incomingChange = action?.data?.data || {}

    yield put(
        blockSaveCustomData(module, entId, blockKey, {
            ...customData,
            assignedTenders: {
                ...(customData?.assignedTenders || {}),
                details: {
                    ...(customData?.assignedTenders?.details || {}),
                    [tenderId]: {
                        ...(customData?.assignedTenders?.details?.[tenderId] || {}),
                        publishers: {
                            ...(customData?.assignedTenders?.details?.[tenderId]?.publishers || {}),
                            ...incomingChange,
                        },
                    },
                },
            },
        })
    )

    return null
}

export default function* assignedTendersPublishersSaga() {
    yield all([
        takeEvery(ASSIGNED_TENDERS_LOAD_PUBLISHERS_DATA, loadPublishersCallSaga),
        takeEvery(ASSIGNED_TENDERS_PUBLISHERS_TABLE_LOADING_TRUE, assignedTendersPublishersSaveCustomDataCallSaga),
        takeEvery(ASSIGNED_TENDERS_PUBLISHERS_TABLE_LOADING_FALSE, assignedTendersPublishersSaveCustomDataCallSaga),
        takeEvery(ASSIGNED_TENDERS_PUBLISHERS_TABLE_LOADING_FAILED, assignedTendersPublishersSaveCustomDataCallSaga),
        takeEvery(ASSIGNED_TENDERS_PUBLISHERS_TABLE_DATA_RECEIVED, assignedTendersPublishersSaveCustomDataCallSaga),
    ])
}
